import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ticketEmailSettingsEffects } from 'src/app/root-store/tickets-store/effects';
import { reducer, ticketingEmailFeatureKey } from 'src/app/root-store/tickets-store/ticket-email-settings.reducer';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(ticketingEmailFeatureKey, reducer),
        EffectsModule.forFeature(ticketEmailSettingsEffects)
    ]
})
export class TicketEmailSettingsStoreModule {}
